export class ResizeElem {
  constructor() {
    this.nowHeight = 0;
    this.nowHeight = 0;
  }

  getStyle(e, styleName) {
    var styleValue = "";
    if (document.defaultView && document.defaultView.getComputedStyle) {
      styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
    } else if (e.currentStyle) {
      styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
        return p1.toUpperCase();
      });
      styleValue = e.currentStyle[styleName];
    }
    return styleValue.replace(/px/g, "");
  }

  setProps(el, props) {
    for (let key in props) {
      el.style.setProperty("--" + key, props[key]);
    }
  }

  init() {}

  isResized() {
    //ウインドウサイズが変わった場合のみ実行したい
    this.body = document.getElementsByTagName("body")[0];

    let resizeFlg = false;
    if (this.body.classList.contains("os-ios") || this.body.classList.contains("os-android")) {
      //モバイルは幅のみで判定、高さはスクロール時にURLバーの大きさが変わる
      if (this.windowWidth !== this.nowWidth) {
        resizeFlg = true;
        // console.log("window size changed mobile");
      }
    } else {
      //PC高さも
      if (this.windowWidth !== this.nowWidth || this.windowHeight !== nowHeight) {
        resizeFlg = true;
        //console.log("window size changed PC");
      }
    }
    return resizeFlg;
  }

  resizing() {
    this.nowWidth = window.innerWidth;
    this.nowHeight = window.innerHeight;
    this.body = document.getElementsByTagName("body")[0];

    let windowRatio = this.nowWidth / this.nowHeight;
    let windowRatioMode = "sp";
    // if (windowRatio <= 9 / 14) {//0.64
    //   windowRatioMode = "tablet";
    // } else if (windowRatio <= 9 / 8) {//1.125
    //   windowRatioMode = "pc";
    // }

    if (windowRatio >= 9 / 8) {
      //1.125
      windowRatioMode = "pc";
    } else if (windowRatio >= 9 / 14) {
      //0.64
      windowRatioMode = "tablet";
    } else {
      windowRatioMode = "sp";
    }

    let windowSizeChanged = this.isResized();
    if (windowSizeChanged) {
      if (document.querySelectorAll(".js-fix-height")[0]) {
        let elems = document.querySelectorAll(".js-fix-height");

        for (let i = 0; i < elems.length; i++) {
          //3カラムのタイトルの高さを調整

          if (elems[i].classList.contains("lp-service__points-grid")) {
            //小要素のh4の高さを取得して、最大の数値を取得
            let h4s = elems[i].querySelectorAll(".js-fix-height-inner");
            let maxH = 0;

            //初期化
            for (let j = 0; j < h4s.length; j++) {
              h4s[j].style.height = "auto";
            }

            for (let j = 0; j < h4s.length; j++) {
              let h = h4s[j].offsetHeight;
              //console.log(h);
              if (h > maxH) {
                maxH = h;
              }
            }
            if (windowRatioMode !== "pc") {
              //console.log(windowRatio, windowRatioMode, "resize auto");
              for (let j = 0; j < h4s.length; j++) {
                h4s[j].style.height = "auto";
              }
            } else {
              //console.log(windowRatio, windowRatioMode, "resize pc");
              //すべてのh4要素に最大の高さを設定
              for (let j = 0; j < h4s.length; j++) {
                h4s[j].style.height = maxH + "px";
              }
            }
          }
        }
      }

      // スクロール scroll-signifier
      let circleHeight = (462 / 1440) * this.nowWidth; //.index-cover__circleの高さ
      let signifierHeight = 80; //120;
      let headerheightpc = 100; //cssで指定
      let underHeight = 0.5 * (this.nowHeight - circleHeight) - 0.3 * headerheightpc;
      console.log("underHeight", underHeight);
      if (underHeight < signifierHeight) {
        this.body.classList.add("ratio-hide-scroll-signifier");
      } else {
        this.body.classList.remove("ratio-hide-scroll-signifier");
      }
    }
  }
}
